<template>
  <v-app>
    <router-view />

    <!-- global-loading -->
    <v-overlay :value="showLoading" z-index="99990">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-overlay>

    <!-- global-[alert|confirm|prompt] -->
    <message-dialog></message-dialog>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data () {
    return {}
  },
  computed: {
    ...mapState({ showLoading: state => state.loadingNum > 0 })
  },
  components: {
    MessageDialog: () => import('@/components/Message/MessageDialog.vue')
  }
}
</script>